/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Linked products select
  
  document.querySelectorAll('.linkedProductSelect').forEach(function(select) {
    select.addEventListener('change', function () {
      const url = this.options[this.selectedIndex].dataset.href;
      if (url) {
        window.location.href = url;
      }
    });
  });

  // Comparison chart mobile slider
    const swiper = new Swiper('.competitors-slider', {
    direction: 'horizontal', 
    loop: true,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      900: {
        enabled: false, // disable above tablet
      }
    }
  });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
